import React from 'react';

/* A cosmetic line plot honouring the chart rules: horizontal gridlines only,
   single series in --accent, benchmark as a dashed --text-tertiary ghost line,
   drawdown shading in --loss-dim at 18% filling DOWNWARD from the running peak.
   Production uses TradingView Lightweight Charts — this exists so mocks, kits
   and specimen cards can show a correctly-styled chart without pulling a
   charting library in. */

export function EquityPlot({
  data = [], benchmark = null, width = 720, height = 240, drawdown = false,
  colour = 'var(--accent)', gridlines = 4, style,
}) {
  if (data.length < 2) return <div style={{ height, ...style }} />;
  const all = benchmark ? data.concat(benchmark) : data;
  const min = Math.min(...all), max = Math.max(...all);
  const span = (max - min) || 1;
  const pad = 8;
  const X = (i, n) => pad + (i / (n - 1)) * (width - pad * 2);
  const Y = (v) => pad + (1 - (v - min) / span) * (height - pad * 2);
  const path = (arr) => arr.map((v, i) => (i ? 'L' : 'M') + X(i, arr.length).toFixed(1) + ' ' + Y(v).toFixed(1)).join(' ');

  return (
    <svg viewBox={'0 0 ' + width + ' ' + height} preserveAspectRatio="none" width="100%" height={height}
      style={{ display: 'block', ...style }} aria-hidden="true">
      {Array.from({ length: gridlines }, (_, i) => {
        const y = pad + ((i + 1) / (gridlines + 1)) * (height - pad * 2);
        return <line key={i} x1={0} x2={width} y1={y} y2={y} stroke="var(--border-subtle)" strokeWidth="1" />;
      })}
      {drawdown ? (
        <path d={path(data) + ' L' + X(data.length - 1, data.length) + ' ' + Y(min) + ' L' + X(0, data.length) + ' ' + Y(min) + ' Z'}
          fill="var(--loss-dim)" fillOpacity=".18" stroke="none" />
      ) : null}
      {benchmark ? (
        <path d={path(benchmark)} fill="none" stroke="var(--text-tertiary)" strokeWidth="1" strokeDasharray="4 3" />
      ) : null}
      <path d={path(data)} fill="none" stroke={colour} strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
}
